import { render, staticRenderFns } from "./Personels.vue?vue&type=template&id=44f8618a&scoped=true"
import script from "./Personels.vue?vue&type=script&lang=js"
export * from "./Personels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f8618a",
  null
  
)

export default component.exports